import React, { memo } from 'react';

function Index() {
  return (
    <>
      <section className="terms-page" style={{ backgroundImage: `url(/assets/img/privacy-bg.webp)` }}>
        <div className="container">
          <h2>Terms & Conditions</h2>
          <p>Your Guide to Safe and Secure Ad Posting - Read, Understand, and Agree to Our Terms and Conditions</p>
        </div>
      </section>
      <section className="terms-sec">
        <div className="container">
          <p>
            Creating comprehensive Terms and Conditions for a 247torax escort services ads posting website is crucial to
            ensure clarity and legal compliance. Here's a simplified version to get you started. Please consult with a
            legal professional to tailor these terms to your specific needs.
          </p>
          <div className="privacy-inner">
            <h4>Terms and Conditions :</h4>
            <ol>
              <li>
                <b>Acceptance of Terms</b>
              </li>
              <ul>
                <li>
                  By using the 247torax escort services Ads Posting website , you agree to abide by these Terms and
                  Conditions. If you do not agree, please refrain from using the Website.
                </li>
              </ul>

              <li>
                <b>Eligibility</b>
              </li>
              <ul>
                <li>Users must be at least 18 years old to use our services.</li>
              </ul>
              <li>
                <b>User Conduct</b>
              </li>
              <ul>
                <li>Users are responsible for their actions on the Website.</li>
                <li>Content posted must adhere to our content guidelines and legal regulations.</li>
                <li>Respect the privacy and rights of others</li>
              </ul>
              <li>
                <b>Advertisements</b>
              </li>
              <ul>
                <li>Users posting escort services ads are responsible for accurate content.</li>
                <li>Prohibited content includes illegal services, explicit content, and false information.</li>
                <li>247torax reserves the right to remove or modify ads that violate guidelines.</li>
              </ul>
              <li>
                <b>Privacy</b>
              </li>
              <ul>
                <li>247torax values user privacy; please refer to our Privacy Policy for details.</li>
              </ul>
              <li>
                <b>Intellectual Property</b>
              </li>
              <ul>
                <li>Users retain intellectual property rights for their content.</li>
                <li>247torax may use user-generated content for promotional purposes with consent.</li>
              </ul>
              <li>
                <b>Disclaimers</b>
              </li>
              <ul>
                <li>247torax is not responsible for the quality or legality of services offered in ads.</li>
                <li>Users use the Website at their own risk.</li>
              </ul>
              <li>
                <b>Termination</b>
              </li>
              <ul>
                <li>247torax may suspend or terminate accounts for violations.</li>
                <li>Users can terminate their accounts at any time.</li>
              </ul>
              <li>
                <b>Modifications</b>
              </li>
              <ul>
                <li>247torax reserves the right to modify these Terms and Conditions.</li>
                <li>Users will be notified of changes.</li>
              </ul>
              <li>
                <b>Governing Law</b>
              </li>
              <ul>
                <li>These Terms and Conditions are governed by the laws of Jaipur Jurisdiction.</li>
              </ul>
              <li>
                <b>Contact</b>
              </li>
              <ul>
                <li>For questions or concerns, please contact us at the website Contact us page .</li>
                <li>
                  By using the 247torax Ads Posting website, you acknowledge that you have read, understood, and agree
                  to these Terms and Conditions.
                </li>
              </ul>
            </ol>
          </div>
        </div>
      </section>
    </>
  );
}

export default memo(Index);
